import React from 'react'
import { Icon } from '../../atoms/Icon'
import { MetricsDisplayProps } from './MetricsDisplay.types'
import {
  MetricsGrid,
  MetricItem,
  MetricIcon,
  MetricValue,
  MetricLabel,
} from './MetricsDisplay.styles'

export const MetricsDisplay: React.FC<MetricsDisplayProps> = ({
  metrics,
  columns = 'auto',
  minColumnWidth = '100px',
  showBorders = true,
  className,
}) => {
  return (
    <MetricsGrid
      $columns={columns}
      $minColumnWidth={minColumnWidth}
      $showBorders={showBorders}
      className={className}
    >
      {metrics.map((metric, index) => (
        <MetricItem key={index}>
          {metric.icon && (
            <MetricIcon>
              <Icon name={metric.icon} size="small" />
            </MetricIcon>
          )}
          <MetricValue>{metric.value}</MetricValue>
          <MetricLabel>{metric.label}</MetricLabel>
        </MetricItem>
      ))}
    </MetricsGrid>
  )
}
